import { AUTH_BASE_URL } from '../config/api';

const API_BASE_URL = AUTH_BASE_URL;

export const fetchConversations = async (limit = null, cursor = null) => {
  const params = new URLSearchParams();
  if (limit) params.append('limit', limit);
  if (cursor) params.append('cursor', cursor);

  const url = `${API_BASE_URL}/api/conversations${params.toString() ? `?${params.toString()}` : ''}`;

  const response = await fetch(url, {
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Failed to fetch conversations');
  }

  return response.json();
};

export const fetchConversation = async (id) => {
  const response = await fetch(`${API_BASE_URL}/api/conversations/${id}`, {
    credentials: 'include',
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch conversation');
  }
  
  return response.json();
};

export const createConversation = async (title = 'New Chat') => {
  const response = await fetch(`${API_BASE_URL}/api/conversations`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ title }),
  });
  
  if (!response.ok) {
    throw new Error('Failed to create conversation');
  }
  
  return response.json();
};

export const updateConversation = async (id, updates) => {
  const response = await fetch(`${API_BASE_URL}/api/conversations/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(updates),
  });
  
  if (!response.ok) {
    throw new Error('Failed to update conversation');
  }
  
  return response.json();
};

export const deleteConversation = async (id) => {
  const response = await fetch(`${API_BASE_URL}/api/conversations/${id}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  
  if (!response.ok) {
    throw new Error('Failed to delete conversation');
  }
  
  return response.json();
};